// useProductVariantEditor.ts
import { useContext } from 'react';
import { ProductVariantEditorContext, ProductVariantEditorContextProps } from '../context/ProductVariantEditorContext';

export const useProductVariantEditor = (): ProductVariantEditorContextProps => {
  const context = useContext(ProductVariantEditorContext);
  if (!context) {
    throw new Error('useProductVariantEditor must be used within a ProductVariantEditorProvider');
  }
  return context;
};
